import type { SVGProps } from "react";
import { memo } from "react";
const ComprehendMedical = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M20.966 18.581v35.327l-6.79-33.93zm31-3.354L57.336 20h-5.37zm-29-1.227h27v7a1 1 0 0 0 1 1h8v23h2V21a1 1 0 0 0-.336-.747l-9-8a1 1 0 0 0-.664-.253h-29a1 1 0 0 0-1 1v3.539l-8.167 1.681a1 1 0 0 0-.78 1.175l8.967 44.802.019-.004a.985.985 0 0 0 .96.807h24v-2h-23zm4 37h18v-2h-18zm0-6h25v-2h-25zm0-18h19v-2h-19zm0 12h27v-2h-27zm9-6h18v-2h-18zm-9 0h7v-2h-7zm39 27h-5a1 1 0 0 0-1 1v5h-5v-5a1 1 0 0 0-1-1h-5v-5h5a1 1 0 0 0 1-1v-5h5v5a1 1 0 0 0 1 1h5zm1-7h-5v-5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v5h-5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1"
      />
    </g>
  </svg>
);
const Memo = memo(ComprehendMedical);
export default Memo;
